import { gql } from "lib/apolloClient";

export const updateAttachmentMutation = gql`
  mutation updateAttachment($input: AttachmentUpdateInput!) {
    platform {
      updateAttachment(input: $input) {
        id
      }
      __typename
    }
  }
`;

export const deleteAttachmentMutation = gql`
  mutation deleteAttachment($input: [ID]!) {
    platform {
      deleteAttachments(attachmentIds: $input) {
        isSuccess
      }
      __typename
    }
  }
`;

export const updateLockedStateMutation = gql`
  mutation updateLockedState($input: LearningCourseEntityLockUpdateInput!) {
    planner {
      bulkUpdateLearningCourseEntityLock(input: $input) {
        isSuccess
      }
    }
  }
`;
